import constants from '@/constants'

const defaultState = {
  courses: null,
  contentWBTEvents: {},
  courseDetails: null,
  participations: {},
  categoryFilters: [],
  sort: constants.COURSES.SORT_RECENT,
  filter: constants.COURSES.FILTER_ALL,
  searchQuery: null,
  searchOpen: false,
}

export default defaultState
